import { gql } from '@apollo/client';

export const FETCH_MEMBERSHIP_PROMO_CODE = gql`
  query Flex_FetchMembershipPromoCode($promoCode: String!, $userId: Int!) {
    promoCode: userPromoCode(promoCode: $promoCode) {
      sponsorName
    }
    user(id: $userId) {
      id
      signupIncentives {
        sponsoredMembership
      }
    }
  }
`;
